module.exports = __webpack_public_path__ + "static/media/logo.52198d94.svg";